// export * from './date/quarter'
import { detect } from './date/detect'
import { format } from './date/format'
import { parseDateFormatString } from './date/parseDateFormatString'
import { parseDateFormatStringAsRange } from './date/parseDateFormatStringAsRange'
import { quarterRange, range } from './date/range'

export const dateUtil = {
  detect,
  range,
  quarterRange,
  format,
  parseDateFormatString,
  parseDateFormatStringAsRange,
}
